import styles from "../MoveOutChecklist.module.css";
import { useEffect, useRef, useState } from "react";
import { Button, Drawer, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ChevronDown, UploadCloud, X } from "react-feather";
import { Badge, PhaseBanner } from "./CommonComponents";
import { toast } from "react-smart-toaster";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import dayjs from "dayjs";
import SignatureCanvas from "react-signature-canvas";

const ROOMS = [
    {
        key: "living_room_data",
        name: "Living Room",
        areas: [
            {
                "key": "livingRoomfloorCovering",
                "label": "Floor and Floor Covering"
            },
            {
                "key": "livingRoomWallsCeiling",
                "label": "Walls and Ceiling"
            },
            {
                "key": "livingRoomWindow",
                "label": "Window(s)"
            },
            {
                "key": "livingRoomWindowConvering",
                "label": "Window Covering(s)"
            },
            {
                "key": "livingRoomLightingFans",
                "label": "Lighting Fixture(s)/ Fans"
            },
            {
                "key": "livingRoomDoorHardware",
                "label": "Door(s) / Hardware"
            },
            {
                "key": "livingRoomHeating",
                "label": "Heating"
            },
            {
                "key": "livingRoomOutletsSwitches",
                "label": "Outlets / Switches"
            },
            {
                "key": "livingRoomSmokeAlarm",
                "label": "Smoke Alarms / CO Alarms"
            },
            {
                "key": "livingRoomOther",
                "label": "Other"
            }
        ],
    },
    {
        key: "kitchen_data",
        name: "Kitchen/Other",
        areas: [
            {
                "key": "kitchenfloorCovering",
                "label": "Floor and Floor Covering"
            },
            {
                "key": "kitchenWallsCeiling",
                "label": "Walls and Ceiling / Caulking"
            },
            {
                "key": "kitchenWindow",
                "label": "Window(s)"
            },
            {
                "key": "kitchenWindowConvering",
                "label": "Window Covering(s)"
            },
            {
                "key": "kitchenLightingFans",
                "label": "Lighting Fixture(s) / Fans"
            },
            {
                "key": "kitchenDoorHardware",
                "label": "Door(s) / Hardware"
            },
            {
                "key": "kitchenHeating",
                "label": "Heating"
            },
            {
                "key": "kitchenOutletsSwitches",
                "label": "Outlets / Switches"
            },
            {
                "key": "kitchenSmokeAlarm",
                "label": "Smoke Alarms / CO Alarms"
            },
            {
                "key": "kitchenCabinetsHardware",
                "label": "Cabinets / Hardware"
            },
            {
                "key": "kitchenRefrigerator",
                "label": "Refrigerator"
            },
            {
                "key": "kitchenStoveOven",
                "label": "Stove / Oven"
            },
            {
                "key": "kitchenStoveVent",
                "label": "Stove Vent"
            },
            {
                "key": "kitchenMicrowave",
                "label": "Microwave"
            },
            {
                "key": "kitchenDishwasher",
                "label": "Dishwasher"
            },
            {
                "key": "kitchenSinkFixtures",
                "label": "Sink / Fixtures / Plumbing"
            },
            {
                "key": "kitchenCounter",
                "label": "Counter"
            },
            {
                "key": "kitchenGarbageDisposal",
                "label": "Garbage Disposal"
            },
            {
                "key": "kitchenWasherDryer",
                "label": "Washer / Dryer"
            },
            {
                "key": "kitchenDryerVent",
                "label": "Dryer Vent"
            },
            {
                "key": "kitchenOther",
                "label": "Other"
            }
        ],
    },
    {
        key: "bathroom_data",
        name: "Bathroom(S)",
        areas: [
            {
                "key": "bathroomfloorCovering",
                "label": "Floor and Floor Covering"
            },
            {
                "key": "bathroomWallsCeiling",
                "label": "Walls and Ceiling / Caulking"
            },
            {
                "key": "bathroomWindow",
                "label": "Window(s)"
            },
            {
                "key": "bathroomWindowConvering",
                "label": "Window Covering(s)"
            },
            {
                "key": "bathroomLightingFans",
                "label": "Lighting Fixture(s) / Fans"
            },
            {
                "key": "bathroomDoorHardware",
                "label": "Door(s) / Hardware"
            },
            {
                "key": "bathroomHeating",
                "label": "Heating"
            },
            {
                "key": "bathroomOutletsSwitches",
                "label": "Outlets / Switches"
            },
            {
                "key": "bathroomSmokeAlarm",
                "label": "Smoke Alarms / CO Alarms"
            },
            {
                "key": "bathroomCabinetsHardware",
                "label": "Cabinets / Hardware"
            },
            {
                "key": "bathroomCounterSurfaces",
                "label": "Counter Surfaces"
            },
            {
                "key": "bathroomSinkFixtures",
                "label": "Sink / Fixtures / Plumbing"
            },
            {
                "key": "bathroomBathtubShower",
                "label": "Bathtub / Shower / Fixtures"
            },
            {
                "key": "bathroomToilet",
                "label": "Toilet"
            },
            {
                "key": "bathroomOther",
                "label": "Other"
            }
        ],
    },
    {
        key: "bedroom_data",
        name: "Bedroom",
        areas: [
            {
                "key": "bedroomfloorCovering",
                "label": "Floor and Floor Covering"
            },
            {
                "key": "bedroomWallsCeiling",
                "label": "Walls and Ceiling"
            },
            {
                "key": "bedroomWindow",
                "label": "Window(s)"
            },
            {
                "key": "bedroomWindowConvering",
                "label": "Window Covering(s)"
            },
            {
                "key": "bedroomLightingFans",
                "label": "Lighting Fixture(s) / Fans"
            },
            {
                "key": "bedroomDoorHardware",
                "label": "Door(s) / Hardware"
            },
            {
                "key": "bedroomHeating",
                "label": "Heating"
            },
            {
                "key": "bedroomOutletsSwitches",
                "label": "Outlets / Switches"
            },
            {
                "key": "bedroomSmokeAlarm",
                "label": "Smoke Alarms / CO Alarms"
            },
            {
                "key": "bedroomOther",
                "label": "Other"
            }
        ],
    },
    {
        key: "other_data",
        name: "Other",
        areas: [
            {
                "key": "otherExteriorOfBuilding",
                "label": "Exterior of Building"
            },
            {
                "key": "otherLawnGarden",
                "label": "Lawn / Garden"
            },
            {
                "key": "otherDrivewayWalkways",
                "label": "Driveway / Walkways"
            },
            {
                "key": "otherGarage",
                "label": "Garage"
            },
            {
                "key": "otherPorch",
                "label": "Porch"
            },
            {
                "key": "keyfobs",
                "label": "# key fobs received"
            },
            {
                "key": "physicalkeys",
                "label": "# of physical keys received"
            },
            {
                "key": "mailboxkeys",
                "label": "# of mailbox keys given"
            },
            {
                "key": "otherOther",
                "label": "Other"
            }
        ],
    },
];

const CheckListTab = ({ moveoutData, submitMoveoutChceckList, setLoading, setTab, propertyDetails }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [roomOpen, setRoomOpen] = useState({ living_room_data: true, kitchen_data: false, bathroom_data: false, bedroom_data: false, other_data: false });
    const [conds, setConds] = useState({ living_room_data: {}, kitchen_data: {}, bathroom_data: {}, bedroom_data: {}, other_data: {} });
    const [uploadedImages, setUploadedImages] = useState({ living_room_data: [], kitchen_data: [], bathroom_data: [], bedroom_data: [], other_data: [] });

    const [comments, setComments] = useState("");
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [currentSigner, setCurrentSigner] = useState(null);
    const [managerSignature, setManagerSignature] = useState(null);
    const [tenant1Signature, setTenant1Signature] = useState(null);
    const [tenant2Signature, setTenant2Signature] = useState(null);
    const [tenant3Signature, setTenant3Signature] = useState(null);
    const signaturePadRef = useRef();

    useEffect(() => {
        if (moveoutData?.manager_sign) {
            const managerSignFileName = moveoutData?.manager_sign.split("/").pop();

            setManagerSignature({ file_path: managerSignFileName, file_url: moveoutData?.manager_sign })
        }

        if (moveoutData?.tenant1_sign) {
            const tenant1SignFileName = moveoutData?.tenant1_sign.split("/").pop();

            setTenant1Signature({ file_path: tenant1SignFileName, file_url: moveoutData?.tenant1_sign })
        }

        if (moveoutData?.tenant2_sign) {
            const tenant2SignFileName = moveoutData?.tenant2_sign.split("/").pop();

            setTenant2Signature({ file_path: tenant2SignFileName, file_url: moveoutData?.tenant2_sign })
        }

        if (moveoutData?.tenant3_sign) {
            const tenant3SignFileName = moveoutData?.tenant3_sign.split("/").pop();

            setTenant3Signature({ file_path: tenant3SignFileName, file_url: moveoutData?.tenant3_sign })
        }

    }, [moveoutData]);

    const toggleRoom = (ri) => {
        /*setRoomOpen(prev => {
            let newState = { living_room_data: false, kitchen_data: false, bathroom_data: false, bedroom_data: false, other_data: false };
            newState = { ...newState, [`${ri}`]: !newState[ri] };

            return newState;
        })*/

        setRoomOpen(prev => {
            const wasOpen = !!prev[ri];
            const newState = { living_room_data: false, kitchen_data: false, bathroom_data: false, bedroom_data: false, other_data: false };

            if (!wasOpen) {
                newState[ri] = true;
            }

            return newState;
        })
    }

    const setCond = (room, area, val) => {
        setConds(prev => {
            if (room.key === 'living_room_data') {
                let livingRoomData = prev.living_room_data;

                livingRoomData = { ...livingRoomData, [`${area?.key}`]: { "is_other": 0, "value": val } };
                return { ...prev, living_room_data: livingRoomData };
            }
            if (room.key === 'kitchen_data') {
                let kitchenData = prev.kitchen_data;

                kitchenData = { ...kitchenData, [`${area?.key}`]: { "is_other": 0, "value": val } };
                return { ...prev, kitchen_data: kitchenData };
            }
            if (room.key === 'bathroom_data') {
                let bathroomData = prev.bathroom_data;

                bathroomData = { ...bathroomData, [`${area?.key}`]: { "is_other": 0, "value": val } };
                return { ...prev, bathroom_data: bathroomData };
            }
            if (room.key === 'bedroom_data') {
                let bedroomData = prev.bedroom_data;

                bedroomData = { ...bedroomData, [`${area?.key}`]: { "is_other": 0, "value": val } };
                return { ...prev, bedroom_data: bedroomData };
            }
            if (room.key === 'other_data') {
                let otherData = prev.other_data;

                otherData = { ...otherData, [`${area?.key}`]: { "is_other": 0, "value": val } };
                return { ...prev, other_data: otherData };
            }
            return prev;
        })
    }

    const setCond2 = (room, area, val) => {
        setConds(prev => {
            if (room.key === 'living_room_data') {
                let livingRoomData = prev.living_room_data;

                livingRoomData = { ...livingRoomData, [`${area?.key}`]: { "is_other": 1, "value": val } };
                return { ...prev, living_room_data: livingRoomData };
            }
            if (room.key === 'kitchen_data') {
                let kitchenData = prev.kitchen_data;

                kitchenData = { ...kitchenData, [`${area?.key}`]: { "is_other": 1, "value": val } };
                return { ...prev, kitchen_data: kitchenData };
            }
            if (room.key === 'bathroom_data') {
                let bathroomData = prev.bathroom_data;

                bathroomData = { ...bathroomData, [`${area?.key}`]: { "is_other": 1, "value": val } };
                return { ...prev, bathroom_data: bathroomData };
            }
            if (room.key === 'bedroom_data') {
                let bedroomData = prev.bedroom_data;

                bedroomData = { ...bedroomData, [`${area?.key}`]: { "is_other": 1, "value": val } };
                return { ...prev, bedroom_data: bedroomData };
            }
            if (room.key === 'other_data') {
                let otherData = prev.other_data;

                otherData = { ...otherData, [`${area?.key}`]: { "is_other": 1, "value": val } };
                return { ...prev, other_data: otherData };
            }
            return prev;
        })
    }

    const onNext = () => {
        let data = conds;
        data = { ...data, current_step: 2, comments: comments };

        data = { ...data, living_room_images: uploadedImages?.living_room_data?.map(i => i?.file_path) };

        data = { ...data, bathroom_images: uploadedImages?.bathroom_data?.map(i => i?.file_path) };


        data = { ...data, kitchen_images: uploadedImages?.kitchen_data?.map(i => i?.file_path) };


        data = { ...data, bedroom_images: uploadedImages?.bedroom_data?.map(i => i?.file_path) };


        data = { ...data, other_images: uploadedImages?.other_data?.map(i => i?.file_path) };

        if (managerSignature) {
            data = { ...data, manager_sign: managerSignature?.file_path };
        }
        if (tenant1Signature) {
            data = { ...data, tenant1_sign: tenant1Signature?.file_path };
        }
        if (tenant2Signature) {
            data = { ...data, tenant2_sign: tenant2Signature?.file_path };
        }
        if (tenant3Signature) {
            data = { ...data, tenant3_sign: tenant3Signature?.file_path };
        }

        submitMoveoutChceckList(data);
    }

    const handleImageChange = async (event, key) => {
        const files = Array.from(event.target.files);
        setLoading(true);

        try {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            for (const file of files) {
                const formData = new FormData();
                formData.append("image", file);

                const response = await axios.post(process.env.REACT_APP_PAYMENT_API_URL + `v1/move-out-report-file-upload`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    }
                });

                setUploadedImages(prev => {
                    if (key === 'living_room_data') {
                        let livingRoomData = prev.living_room_data;
                        return { ...prev, living_room_data: livingRoomData.concat(response.data.data) };
                    }
                    if (key === 'kitchen_data') {
                        let kitchenData = prev.kitchen_data;
                        return { ...prev, kitchen_data: kitchenData.concat(response.data.data) };
                    }
                    if (key === 'bathroom_data') {
                        let bathroomData = prev.bathroom_data;
                        return { ...prev, bathroom_data: bathroomData.concat(response.data.data) };
                    }
                    if (key === 'bedroom_data') {
                        let bedroomData = prev.bedroom_data;
                        return { ...prev, bedroom_data: bedroomData.concat(response.data.data) };
                    }
                    if (key === 'other_data') {
                        let otherData = prev.other_data;
                        return { ...prev, other_data: otherData.concat(response.data.data) };
                    }
                    return prev;
                });
            }
            toast.success(`Images are uploaded`);
        } catch (error) {
            if (error?.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Image upload failed");
            }
        } finally {
            setLoading(false);
        }
    }

    const removeImage = (fileName, key) => {
        setUploadedImages(prev => {
            if (key === 'living_room_data') {
                let livingRoomData = prev.living_room_data;
                return { ...prev, living_room_data: livingRoomData.filter((img) => img.file_path !== fileName) };
            }
            if (key === 'kitchen_data') {
                let kitchenData = prev.kitchen_data;
                return { ...prev, kitchen_data: kitchenData.filter((img) => img.file_path !== fileName) };
            }
            if (key === 'bathroom_data') {
                let bathroomData = prev.bathroom_data;
                return { ...prev, bathroom_data: bathroomData.filter((img) => img.file_path !== fileName) };
            }
            if (key === 'bedroom_data') {
                let bedroomData = prev.bedroom_data;
                return { ...prev, bedroom_data: bedroomData.filter((img) => img.file_path !== fileName) };
            }
            if (key === 'other_data') {
                let otherData = prev.other_data;
                return { ...prev, other_data: otherData.filter((img) => img.file_path !== fileName) };
            }
            return prev;
        });
    }

    useEffect(() => {
        let constemp = { living_room_data: {}, kitchen_data: {}, bathroom_data: {}, bedroom_data: {}, other_data: {} };

        if (moveoutData?.living_room_data.length !== 0) {
            constemp = { ...constemp, living_room_data: moveoutData?.living_room_data };
        }

        if (moveoutData?.kitchen_data.length !== 0) {
            constemp = { ...constemp, kitchen_data: moveoutData?.kitchen_data };
        }

        if (moveoutData?.bathroom_data.length !== 0) {
            constemp = { ...constemp, bathroom_data: moveoutData?.bathroom_data };
        }

        if (moveoutData?.bedroom_data.length !== 0) {
            constemp = { ...constemp, bedroom_data: moveoutData?.bedroom_data };
        }

        if (moveoutData?.other_data.length !== 0) {
            constemp = { ...constemp, other_data: moveoutData?.other_data };
        }

        setConds(constemp);

        setUploadedImages({ living_room_data: moveoutData?.living_room_images, kitchen_data: moveoutData?.kitchen_images, bathroom_data: moveoutData?.bathroom_images, bedroom_data: moveoutData?.bedroom_images, other_data: moveoutData?.other_images });
    }, [moveoutData]);

    const submitSignature = async (base64Data, name) => {
        const file = base64Data;

        setLoading(true);
        try {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            const formData = new FormData();
            formData.append("image", file);

            const response = await axios.post(process.env.REACT_APP_PAYMENT_API_URL + `v1/save-sign-image-move-out`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                }
            });

            signaturePadRef.current.clear();

            switch (name) {
                case "tenant1":
                    setTenant1Signature(response.data.data);
                    break;
                case "tenant2":
                    setTenant2Signature(response.data.data);
                    break;
                case "tenant3":
                    setTenant3Signature(response.data.data);
                    break;
                case "manager":
                    setManagerSignature(response.data.data);
                    break;
                default:
                    console.log('Not Match');
            }

        } catch (error) {
            console.error("Signature Upload error:", error);
            toast.error(error?.response?.data?.message || "Signature upload failed");
        } finally {
            setLoading(false);
        }
    }

    const setCondParent = (rm, newVal) => {
        ROOMS.forEach(i => {
            if (rm.key === i?.key) {
                i?.areas.forEach(j => {
                    if (j?.label !== "Other" && j?.key !== "keyfobs" && j?.key !== "physicalkeys" && j?.key !== "mailboxkeys") {
                        setCond(rm, j, newVal);
                    }
                })
            }
        })
    }

    return <>
        <div className={`${styles.tp} ${styles.tpActive}`}>
            <PhaseBanner
                type="green"
                icon="clipboard-check"
                title="Phase 2 — Inspection in progress"
                sub="Walk through each room. Complete the checklist before generating the final statement."
            />

            <div>

                {ROOMS.map((room, ri) => {
                    const isOpen = roomOpen[room?.key] && roomOpen[room?.key] !== false;
                    const hasPoor = false;
                    const allGood = false;

                    return (<div className={styles.accord} key={ri}>
                        <button className={`${styles.accordHdr} FormGroup`} onClick={() => toggleRoom(room?.key)}>
                            <span>
                                {room.name}
                                {hasPoor && (<Badge type="danger" style={{ marginLeft: 8 }}>Damage</Badge>)}
                                {!hasPoor && allGood && (<Badge type="success" style={{ marginLeft: 8 }}>All good</Badge>)}
                            </span>
                            <div className={`${styles.MainSelectSec}`} onClick={(e) => e.stopPropagation()}>
                                <FormControl fullWidth className={`${styles.CustomWidthSelect}`}>
                                    <InputLabel id="demo-simple-select-label">Select</InputLabel>
                                    <Select label="Select" onChange={(e) => { setCondParent(room, e.target.value); }}>
                                        <MenuItem value={"New"}>New</MenuItem>
                                        <MenuItem value={"Normal"}>Normal</MenuItem>
                                        <MenuItem value={"Damaged"}>Damaged</MenuItem>
                                        <MenuItem value={"N/A"} >N/A</MenuItem>
                                    </Select>
                                </FormControl>
                                <ChevronDown className={`${styles.accordHdrChev} ${isOpen ? styles.accordHdrChevOpen : ""}`} />
                            </div>
                        </button>

                        {isOpen && (<div className={styles.accordBody}>
                            {room.areas.map((area, ai) => {
                                let val = conds[room.key][area.key]?.value || "";
                                let val2 = "";
                                const isOther = conds[room.key][area.key]?.is_other || 0;

                                if (isOther === 1) {
                                    val2 = val;
                                    val = "Other";
                                }

                                if (area?.label === "Other" || area?.key === "keyfobs" || area?.key === "physicalkeys" || area?.key === "mailboxkeys") {
                                    return (<div className={`${styles.areaItem} FormGroup`} key={ai}>
                                        <div className={styles.areaLbl}>{ai + 1}. {area?.label}</div>
                                        <input className={styles.ati} type="text" placeholder={(area?.key === "keyfobs" ? "# key fobs received" : (area?.key === "physicalkeys" ? "# of physical keys received" : (area?.key === "mailboxkeys" ? "# of mailbox keys given" : "Add description")))} value={val || ""} onChange={(e) => { setCond(room, area, e.target.value); }} />
                                    </div>);
                                }
                                return (<div className={`${styles.areaItem} FormGroup`} key={ai}>
                                    <div className={styles.areaLbl}>{ai + 1}. {area?.label.toUpperCase()}</div>
                                    <FormControl fullWidth className={`${styles.CustomWidthSelect}`}>
                                        <InputLabel id="demo-simple-select-label">Select</InputLabel>
                                        <Select value={val || ""} onChange={(e) => { setCond(room, area, e.target.value); }} label="Select ">
                                            <MenuItem value={"New"}>New</MenuItem>
                                            <MenuItem value={"Normal"}>Normal</MenuItem>
                                            <MenuItem value={"Damaged"}>Damaged</MenuItem>
                                            <MenuItem value={"Other"} >Other</MenuItem>
                                            <MenuItem value={"N/A"} >N/A</MenuItem>
                                        </Select>
                                    </FormControl>


                                    {(val === "Other" || isOther === 1) && <input className={styles.ati} type="text" placeholder="Add description" value={val2} onChange={(e) => { setCond2(room, area, e.target.value); }} />}
                                </div>);
                            })}

                            <div className={styles.photoZone} >
                                <label htmlFor="file-upload-bathroom">
                                    <UploadCloud className={`${styles.photoZoneIcon}`} />
                                    <div className={styles.photoZoneTxt}>
                                        <strong>Upload photos</strong> for {room.name}
                                    </div>
                                </label>
                                <input id="file-upload-bathroom" type="file" accept="image/*" multiple onChange={(e) => handleImageChange(e, room.key)} style={{ display: "none" }} />
                            </div>

                            <div className={`${styles.UpIMGSec}`}>
                                {uploadedImages[room.key].map((img, index) => (
                                    <div key={index} className={`${styles.ImgFile}`}>
                                        <img src={img.file_url} alt={img.file_path} />
                                        <Button type="button" onClick={() => removeImage(img.file_path, room.key)}>
                                            <X />
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </div>)}
                    </div>);
                })}
            </div>

            {/* Comments */}
            <div style={{ marginBottom: 16 }}>
                <label className={styles.fl}>Comments</label>
                <div className={styles.cmts}>
                    <textarea placeholder="Comments" onChange={(e) => setComments(e.target.value)} />
                </div>
            </div>

            {/* Signatures */}
            <div className={styles.sigSec}>
                <div className={styles.sigSecTitle}>Move-out Inspection</div>
                <div className={styles.sigBlock}>
                    {managerSignature ? <img src={managerSignature?.file_url} alt="signature" className={`${styles.SignatureImage}`} /> : <button className={`${styles.sigBtn}`} onClick={() => { setCurrentSigner('manager'); setDrawerOpen(true); }}>SIGNATURE</button>}
                    <div className={styles.sigName}>{moveoutData?.signed_by_name}</div>
                    <div className={styles.sigMeta}>Authorized Agent - {propertyDetails?.property_manager}</div>
                </div>
                {/*moveoutData?.tenant1_name && <div className={styles.sigBlock}>
                    {tenant1Signature ? <img src={tenant1Signature?.file_url} alt="signature" className={`${styles.SignatureImage}`} /> : <button className={`${styles.sigBtn}`} onClick={() => { setCurrentSigner('tenant1'); setDrawerOpen(true); }}>SIGNATURE</button>}
                    <div className={styles.sigName}>{moveoutData?.tenant1_name}</div>
                    <div className={styles.sigMeta}>Tenant</div>
                </div>}
                {moveoutData?.tenant2_name && <div className={styles.sigBlock}>
                    {tenant2Signature ? <img src={tenant2Signature?.file_url} alt="signature" className={`${styles.SignatureImage}`} /> : <button className={`${styles.sigBtn}`} onClick={() => { setCurrentSigner('tenant2'); setDrawerOpen(true); }}>SIGNATURE</button>}
                    <div className={styles.sigName}>{moveoutData?.tenant2_name}</div>
                    <div className={styles.sigMeta}>Tenant</div>
                </div>}
                {moveoutData?.tenant3_name && <div className={styles.sigBlock}>
                    {tenant3Signature ? <img src={tenant3Signature?.file_url} alt="signature" className={`${styles.SignatureImage}`} /> : <button className={`${styles.sigBtn}`} onClick={() => { setCurrentSigner('tenant3'); setDrawerOpen(true); }}>SIGNATURE</button>}
                    <div className={styles.sigName}>{moveoutData?.tenant3_name}</div>
                    <div className={styles.sigMeta}>Tenant</div>
                </div>*/}
                <div className={styles.sigDate}>
                    Date of Move-out Inspection <strong>{dayjs(moveoutData?.inspection_date).format("MMM DD, YYYY")}</strong>
                </div>
            </div>

            <div className={styles.fa}>
                <button className={`${styles.btn} ${styles.btnS}`} onClick={() => { setTab(p => p - 1) }}>
                    <i className="ti ti-arrow-left" /> Back
                </button>
                <div className={styles.faRight}>
                    <button className={`${styles.btn} ${styles.btnP}`} onClick={onNext} disabled={!managerSignature}>
                        Add Damage Cost <i className="ti ti-arrow-right" />
                    </button>
                </div>
            </div>
        </div>

        <Drawer
            anchor="bottom"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            className="ChecklistSignDrawer"
            ModalProps={{
                keepMounted: true, // improves performance on mobile
            }}
        >
            <div className={`${styles.DrawerContent}`}>
                <div className={`${styles.SignDrawerHead}`}>
                    <p className={`${styles.DrawerSigTitle}`}>Sign as {currentSigner === 'manager' ? 'Manager' : 'Tenant'}</p>
                    <button onClick={() => setDrawerOpen(false)} className={`${styles.CloseButton}`} aria-label="Close"><X /></button>
                </div>

                <SignatureCanvas
                    penColor="black"
                    canvasProps={{
                        width: 330,
                        height: 180,
                        className: `${styles.SignatureCanvas}`,
                    }}
                    ref={signaturePadRef}
                />
                <div className={`${styles.ButtonAction}`}>
                    <button onClick={() => signaturePadRef.current.clear()} className={`${styles.CancelPopupBU}`}>Clear</button>
                    <button className={`${styles.SubmitPopupBU}`} variant="contained" onClick={() => {
                        if (signaturePadRef.current.isEmpty()) {
                            toast.error("Signature cannot be empty. Please provide a valid signature before submitting.");
                            return;
                        }
                        const base64 = signaturePadRef.current.toDataURL();
                        submitSignature(base64, currentSigner);
                        setDrawerOpen(false);
                    }}>Ok</button>
                </div>
            </div>
        </Drawer>
    </>
}

export default CheckListTab;